// ECDEV-376: the fixed rejection reasons, in one place. They were duplicated in the Stage-3
// inline list and in the document preview modal, which is how the two drift apart.
export const REJECTION_REASONS: readonly string[] = [
  'Incorrect Information',
  'Shipment Delay',
  'Overweight',
  'Other',
] as const;
